import nodeArray from 'Carbon.Frontend/Resources/Private/Assets/Scripts/nodeArray';
import styles from './MapStyle';
import SnazzyInfoWindow from 'snazzy-info-window';

let maps = nodeArray('.map');

window.initMap = function() {
    maps.forEach(element => {
        // read places from fusion
        let places = nodeArray('.map__location', element).map(item => {
            let data = item.dataset;
            return {
                element: item,
                position: {
                    lat: parseFloat(data.lat),
                    lng: parseFloat(data.lng)
                },
                offset: data.offset
            };
        });

        // check window size and resize map accordingly
        const w = Math.max(
            document.documentElement.clientWidth,
            window.innerWidth || 0
        );
        let zoomLevel = (w > 815 && w < 1390) || w < 520 ? 15 : 16;
        let centerH = w <= 815 ? 12.9568 : 12.9662;

        // create map
        let map = new google.maps.Map(element, {
            styles: styles,
            center: {
                lat: 47.7845,
                lng: centerH
            },
            zoom: zoomLevel,
            streetViewControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
            scrollwheel: false
        });

        // create info boxes
        places.forEach(place => {
            let infoWindow = new SnazzyInfoWindow({
                content: place.element,
                map: map,
                position: new google.maps.LatLng(
                    place.position.lat,
                    place.position.lng
                ),
                maxWidth: 250,
                pointer: false,
                showCloseButton: false,
                closeOnMapClick: false,
                panOnOpen: false,
                padding: '0px',
                border: false,
                shadow: false,
                offset: {
                    top: place.offset
                }
            });
            infoWindow.open();
        });
    });
};
